import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QSSimpleComponent } from './quickstart-simple.component';
import { QSSimpleSelectDeviceComponent } from './select-device/select-device.component';
import { QSSimpleSelectEventComponent } from './select-event/select-event.component';
import { QSSimpleSelectActionComponent } from './select-action/select-action.component';
import { QSSimpleSelectParamsComponent } from './select-params/select-params.component';

export const QUICKSTART_TRIGGERS_SIMPLE_ROUTES: Routes = [
  {
    path: '',
    component: QSSimpleComponent,
    children: [
      {
        path: ':type',
        component: QSSimpleSelectDeviceComponent
      },
      {
        path: 'device/:id',
        component: QSSimpleSelectEventComponent
      }
    ]
  },

];

export const QUICKSTART_ACTIONS_SIMPLE_ROUTES: Routes = [
  {
    path: '',
    component: QSSimpleComponent,
    children: [
      {
        path: ':type',
        component: QSSimpleSelectDeviceComponent
      },
      {
        path: 'device/:id',
        component: QSSimpleSelectActionComponent
      },
      {
        path: 'device/:id/:command',
        component: QSSimpleSelectParamsComponent
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/quickstart-simple.routes.ts